import React, { useState, useEffect, ReactNode } from "react";
import { Box } from '@mui/material';

interface PublicLayoutProps {
  children: ReactNode;
}

const PublicLayout = ({ children }: PublicLayoutProps) => {
  return (
    <>
      <Box
          display="flex"
          justifyContent="center"
          alignItems="top"
          height="100vh"
          bgcolor="#f5f5f5"
          sx={{
              borderRadius: "32px",
          }}
          p={"20px"}
      >

          {children}

      </Box>
    </>
  );
};

export default PublicLayout;

